import React from "react";
import { Radar, Activity } from "lucide-react";

export default function Header({ stats, rightSlot }) {
  const total = stats?.total ?? "—";
  const unresolved = stats?.unresolved ?? "—";
  return (
    <header
      data-testid="app-header"
      className="border-b border-zinc-800 bg-zinc-950/80 backdrop-blur sticky top-0 z-30"
    >
      <div className="px-6 py-4 flex items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <div className="relative">
            <Radar className="h-6 w-6 text-amber-400" strokeWidth={1.5} />
            <span className="absolute -bottom-0.5 -right-0.5 h-2 w-2 bg-amber-400 animate-pulse-amber rounded-full" />
          </div>
          <div className="flex flex-col leading-tight">
            <span
              className="font-chivo font-extrabold text-base tracking-tight"
              data-testid="brand-title"
            >
              PURSUE
            </span>
            <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
              Presidential Unsealing &amp; Reporting System / UAP Encounters
            </span>
          </div>
        </div>

        <div className="hidden md:flex items-center gap-6 font-mono text-[11px] uppercase tracking-widest">
          <div className="flex flex-col items-end">
            <span className="text-zinc-500">Total Cases</span>
            <span data-testid="header-total" className="text-zinc-100 text-sm font-semibold">
              {String(total).padStart(3, "0")}
            </span>
          </div>
          <div className="h-8 w-px bg-zinc-800" />
          <div className="flex flex-col items-end">
            <span className="text-zinc-500">Unresolved</span>
            <span data-testid="header-unresolved" className="text-amber-400 text-sm font-semibold">
              {String(unresolved).padStart(3, "0")}
            </span>
          </div>
          <div className="h-8 w-px bg-zinc-800" />
          <div className="flex items-center gap-2 text-zinc-400">
            <Activity className="h-3.5 w-3.5 text-emerald-400 animate-pulse" />
            <span>FEED ACTIVE</span>
          </div>
          {rightSlot}
        </div>
      </div>
    </header>
  );
}
